import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

const ExampleOneContent = lazy(async () => {
  const loaded = await import(/* webpackChunkName: 'right_rail_example' */'./examples')
  return { default: loaded.ExampleOne }
})

const ExampleTwoContent = lazy(async () => {
  const loaded = await import(/* webpackChunkName: 'right_rail_example' */'./examples')
  return { default: loaded.ExampleTwo }
})

export const ExampleOne = withSafeSuspense(ExampleOneContent)
export const ExampleTwo = withSafeSuspense(ExampleTwoContent)
